import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Row,
  Col,
  Popconfirm,
  App,
  Upload,
  Modal,
  Spin,
  Menu,
  Checkbox,
  Dropdown,
  Tabs,
  Drawer,
  
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedCustomer, setIsEditCustomer } from "../customersSlice";
import { fetchCustomersList, deleteCustomer } from "../customersThunks";
import { getAccessType } from "../../../lib/functions";
import { BACKEND_API_URL } from "../../../environment";

import Papa from "papaparse";
import axios from "axios";
import { useIsAdminUser } from "../../../lib/accessList";
import "./customer.css";

const ALL_CUSTOMER_COLUMNS = [
  { key: "acc_name", label: "Customer Name" },
  { key: "acc_code", label: "Code" },
  { key: "party_type", label: "Type" },
  { key: "contact_no", label: "Contact No" },
  { key: "location_name", label: "Area" },
  { key: "opening_balance", label: "Opening Due" },
  { key: "user_full_name", label: "Entry By" },
  { key: "credit_limit", label: "Credit Limit" },
  { key: "credit_Month", label: "Credit Month" },
  { key: "institution_name", label: "Institution" },
  { key: "address", label: "Address" },
  { key: "licence_no", label: "Licence No" },
  { key: "vat_no", label: "VAT No" },
];

const DEFAULT_VISIBLE_COLUMNS = [
  "acc_name",
  "acc_code",
  "party_type",
  "contact_no",
  "opening_balance",
];

const CustomerList = ({ customersList, authInfo }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { message } = App.useApp();

  const [file, setFile] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [previewDataModal, setPreviewDataModal] = useState(false);

  const [downloadURL, setdownloadURL] = useState(null);
  const [downloadURLModal, setDownloadURLModal] = useState(false);
  const [skippedRows, setSkippedRows] = useState([]);
  const [skippedRowsModal, setSkippedRowsModal] = useState(false);

  const [isLoadingFile, isLoadingFileSet] = useState(false);
  const [isLoading, isLoadingSet] = useState(false);

  const [access_type, access_type_set] = useState("");
  const [visibleKeys, setVisibleKeys] = useState(DEFAULT_VISIBLE_COLUMNS);

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);


  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;

  console.log(canEdit, canDelete, "canDelete");
  const isAdminUser = useIsAdminUser();

  const LoaderOverlay = () =>
    isLoading ? (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(255,255,255,0.4)",
          zIndex: 9999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" />
      </div>
    ) : null;

  useEffect(() => {
    access_type_set(getAccessType("customer_entry"));
  }, []);

  useEffect(() => {
    dispatch(fetchCustomersList());
    dispatch(setSelectedCustomer(null));
    dispatch(setIsEditCustomer(false));
  }, [dispatch]);

  const columnMenu = (
    <Menu>
      {ALL_CUSTOMER_COLUMNS.map((col) => (
        <Menu.Item key={col.key}>
          <Checkbox
            checked={visibleKeys.includes(col.key)}
            onChange={(e) => {
              const checked = e.target.checked;
              setVisibleKeys((prev) =>
                checked ? [...prev, col.key] : prev.filter((k) => k !== col.key)
              );
            }}
          >
            {col.label}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );

  const columns = [
    {
      title: "NO.",
      render: (_, __, index) => index + 1,
      width: 60,
    },

    ...ALL_CUSTOMER_COLUMNS.filter((col) => visibleKeys.includes(col.key)).map(
      ({ key, label }) => ({
        title: label,
        dataIndex: key,
        sorter: (a, b) =>
          (a[key] || "").toString().localeCompare((b[key] || "").toString()),
      })
    ),
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            disabled={!(isAdminUser || canEdit)}
            onClick={() => {
              dispatch(setSelectedCustomer(record));
              dispatch(setIsEditCustomer(true));
              navigate("addNewCustomer");
            }}
            icon={<EditOutlined />}
          />

          <Popconfirm
            title="Delete this Customer?"
            disabled={!(isAdminUser || canDelete)}
            onConfirm={async () => {
              try {
                const res = await dispatch(
                  deleteCustomer({ acc_id: record.acc_id })
                ).unwrap();
                if (!res.error) {
                  message.success(res.msg || "Customer deleted successfully");
                  dispatch(fetchCustomersList());
                } else {
                  message.error(res.msg || "Failed to delete customer");
                }
              } catch (err) {
                console.error("Delete error:", err);
                message.error("Error deleting customer");
              }
            }}
            onCancel={(e) => e?.stopPropagation()}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger disabled={!(isAdminUser || canDelete)} icon={<DeleteOutlined />} />
          </Popconfirm>
        </>
      ),
    },
  ];

  const handleDownloadTemplate = async () => {
    try {
      const response = await fetch(
        `${BACKEND_API_URL}/accounts/customer/template-with-data`,
        {
          method: "GET",
          headers: {
            "auth-token": authInfo.token,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Failed to download template");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Customer_Upload_Template.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      message.error("Failed to download template", error);
    }
  };

  // --------------------------------------------------------------
  // FILE UPLOAD + VALIDATION
  // --------------------------------------------------------------
  const handleFileUpload = (info) => {
    const file = info?.file?.originFileObj || info?.file;

    const selectedFile = file;
    if (!selectedFile) return;

    // 500KB Limit
    if (selectedFile.size > 524288) {
      message.warning(
        "File size exceeds 500 KB. Please upload a smaller file."
      );
      return;
    }

    // CSV type validation
    if (
      selectedFile.type !== "text/csv" &&
      !selectedFile.name.toLowerCase().endsWith(".csv")
    ) {
      message.error("Invalid file type. Please upload a CSV file.");
      return;
    }

    setFile(selectedFile);
    isLoadingFileSet(true);

    Papa.parse(selectedFile, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const data = results.data;

        const requiredColumns = [
          "acc_name",
          "opening_balance",
          "institution_name",
          "address",
          "country_code",
          "contact_no",
          "location_name",
          "email_address",
          "credit_limit",
          "credit_day",
          "credit_month",
          "licence_no",
          "licence_validity",
          "vat_no",
          "party_type",
          "po_box",
          "customer_group_name",
        ];

        if (
          !requiredColumns.every((col) => results.meta.fields.includes(col))
        ) {
          message.error(
            "Invalid CSV structure. Please use the correct template."
          );
          isLoadingFileSet(false);
          return;
        }

        // FULL ROW VALIDATIONS
        let isValid = true;

        data.forEach((row, index) => {
          if (!row.acc_name?.trim()) {
            message.error(`Row ${index + 1}: Customer Name is required`);
            isValid = false;
            return;
          }

          if (!row.opening_balance?.trim()) {
            message.error(`Row ${index + 1}: Opening Balance is required`);
            isValid = false;
            return;
          }

          if (!row.party_type?.trim()) {
            message.error(`Row ${index + 1}: Party Type is required`);
            isValid = false;
            return;
          }

          const allowedTypes = [
            "retailer",
            "wholesaler",
            "distributor",
            "corporate",
          ];
          if (!allowedTypes.includes(row.party_type.trim().toLowerCase())) {
            message.error(
              `Row ${index + 1
              }: Invalid Party Type. Allowed: Retailer, Wholesaler, Distributor, Corporate`
            );
            isValid = false;
            return;
          }

          if (
            row.credit_day &&
            row.credit_day !== "0" &&
            row.credit_month &&
            row.credit_month !== "0"
          ) {
            message.error(
              `Row ${index + 1}: Credit Month & Credit Day cannot both be set`
            );
            isValid = false;
            return;
          }

          if (row.country_code && isNaN(row.country_code)) {
            message.error(`Row ${index + 1}: Country Code must be numeric`);
            isValid = false;
            return;
          }

          if (row.contact_no && isNaN(row.contact_no)) {
            message.error(`Row ${index + 1}: Contact No must be numeric`);
            isValid = false;
            return;
          }
        });

        if (isValid) {
          setPreviewData(data);
          setPreviewDataModal(true);
        }

        isLoadingFileSet(false);
      },
    });
  };

  // --------------------------------------------------------------
  // SUBMIT CSV FILE TO BACKEND
  // --------------------------------------------------------------
  const submitFileUpload = async () => {
    const formData = new FormData();
    formData.append("file", file);

    isLoadingSet(true);

    try {
      const response = await axios.post(
        `${BACKEND_API_URL}/accounts/customers/upload-csv`,
        formData,
        {
          headers: {
            "auth-token": authInfo.token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data) {
        message.success(response.data.message || "File uploaded successfully!");

        if (response.data.skippedRows?.length > 0) {
          setSkippedRows(response.data.skippedRows);
          setSkippedRowsModal(true);
          message.warning(`${response.data.skippedRows.length} rows skipped`);
        }

        const url = response.data.downloadUrl;
        if (url) {
          setdownloadURL(`${BACKEND_API_URL}${url}`);
          // setDownloadURLModal(true);
        }

        setPreviewDataModal(false);
        setFile(null);
        setPreviewData([]);
        dispatch(fetchCustomersList());
      }
    } finally {
      isLoadingSet(false);
    }
  };

  // --------------------------------------------------------------
  // DOWNLOAD SKIPPED ROWS
  // --------------------------------------------------------------
  const handleDownloadSkippedRows = async () => {
    try {
      const response = await axios.get(downloadURL, {
        headers: { "auth-token": authInfo.token },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "skipped_rows.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();

      setDownloadURLModal(false);
    } catch {
      message.error("Failed to download skipped rows.");
    }
  };

  return (
    <>
      <LoaderOverlay />

      <Row justify="end" style={{ marginBottom: 32, marginTop: 32 }}>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          className="customer-toolbar"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <Dropdown overlay={columnMenu} placement="bottomRight">
            <Button>Columns</Button>
          </Dropdown>

          {access_type === "WRITE" && (
            <>
              <Upload
                accept=".csv"
                showUploadList={false}
                beforeUpload={() => false}
                customRequest={() => { }}
                onChange={handleFileUpload}
              >
                <Button icon={<UploadOutlined />}>Import CSV</Button>
              </Upload>

              <Button
                htmlType="button"
                icon={<DownloadOutlined />}
                onClick={handleDownloadTemplate}
              >
                Download Template
              </Button>

              <Button
                type="primary"
                icon={<PlusOutlined />}
                className="traic-button"
                data-testid="add-new-customer-button"
                style={{ minWidth: 112, height: 36, fontWeight: 500 }}
                onClick={() => {
                  dispatch(setSelectedCustomer(null));
                  dispatch(setIsEditCustomer(false));
                  navigate("addNewCustomer");
                }}
              >
                Add Customer
              </Button>
            </>
          )}
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={customersList}
        rowKey="acc_id"
        size="small"
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: customersList?.length,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
          onChange: (page) => {
            setCurrentPage(page);
          },
          onShowSizeChange: (_, size) => {
            setPageSize(size);
            setCurrentPage(1);
          },
        }}
        scroll={{ x: "max-content" }}
      />

      {/* PREVIEW MODAL */}
      <Modal
        open={previewDataModal}
        onCancel={() => setPreviewDataModal(false)}
        footer={null}
        width={"70%"}
      >
        {isLoading ? (
          <Spin />
        ) : previewData.length > 0 ? (
          <>
            <h2>File Preview</h2>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingBottom: 10,
              }}
            >
              <span>Rows: {previewData.length}</span>

              <Button type="primary" onClick={submitFileUpload}>
                Submit
              </Button>
            </div>

            <div
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                overflowX: "auto",
                border: "1px solid #ddd",
              }}
            >
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {Object.keys(previewData[0]).map((key) => (
                      <th
                        key={key}
                        style={{
                          padding: 10,
                          background: "#f0f0f0",
                          border: "1px solid #ddd",
                        }}
                      >
                        {key}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {previewData.map((row, index) => (
                    <tr key={index}>
                      {Object.values(row).map((value, idx) => (
                        <td
                          key={idx}
                          style={{
                            padding: 10,
                            border: "1px solid #ddd",
                          }}
                        >
                          {value}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <p>No data available</p>
        )}
      </Modal>

      {/* SKIPPED ROWS MODAL */}
      <Modal
        open={downloadURLModal}
        onCancel={() => setDownloadURLModal(false)}
        footer={null}
        width="30%"
      >
        <Button type="primary" onClick={handleDownloadSkippedRows}>
          Download Skipped Rows
        </Button>
      </Modal>
      <Modal
        open={skippedRowsModal}
        onCancel={() => setSkippedRowsModal(false)}
        footer={null}
        width={"70%"}
      >
        <h2>Skipped Rows Preview</h2>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "10px",
          }}
        >
          <span>Total Skipped: {skippedRows.length}</span>

          <Button
            type="primary"
            onClick={async () => {
              try {
                const response = await axios.get(downloadURL, {
                  headers: { "auth-token": authInfo.token },
                  responseType: "blob",
                });

                const blob = new Blob([response.data], { type: "text/csv" });
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute("download", "skipped_rows.csv");
                document.body.appendChild(link);
                link.click();
                link.remove();

                setSkippedRowsModal(false);
              } catch {
                message.error("Failed to download skipped rows.");
              }
            }}
          >
            Download Skipped Rows
          </Button>
        </div>

        <div
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
            overflowX: "auto",
            border: "1px solid #ddd",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {Object.keys(skippedRows[0] || {}).map((key) => (
                  <th
                    key={key}
                    style={{
                      padding: 10,
                      background: "#f0f0f0",
                      border: "1px solid #ddd",
                    }}
                  >
                    {key}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {skippedRows.map((row, index) => (
                <tr key={index}>
                  {Object.values(row).map((value, idx) => (
                    <td
                      key={idx}
                      style={{
                        padding: 10,
                        border: "1px solid #ddd",
                      }}
                    >
                      {value}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
};

export default CustomerList;
